function mediaQueryChange(mediaQuery) {
  const isDesktop = mediaQuery.matches;

  document.querySelectorAll('.responsive-video').forEach((heroVideo) => {
    const src = isDesktop ? heroVideo.dataset.srcDesktop : '';
    heroVideo.setAttribute('src', src);
  });
}

const mediaQuery = window.matchMedia('(min-width: 640px)');
// Run when changing matched media
mediaQuery.addEventListener('change', mediaQueryChange);
// Run on page load
mediaQueryChange(mediaQuery);



// WEBPACK FOOTER //
// ./scripts/gutenberg_components/_homepage-top-hero-carousel.js